export const SCOPES_CHANGE_DEFAULT_SCOPE = '@@SCOPES/CHANGE_DEFAULT_SCOPE';
export const SCOPES_CLONE_SCOPE = '@@SCOPES/CLONE_SCOPE';
export const SCOPES_SET_NAVIGATION_SCOPE_TARGET = '@@SCOPES/SET_NAVIGATION_SCOPE_TARGET';
export const SCOPES_DELETE_SCOPE = '@@SCOPES/DELETE_SCOPE';
export const SCOPES_CREATE_UNINITIALIZED_SCOPES_FROM_ORDER = '@@SCOPES/CREATE_CREATE_UNINITIALIZED_SCOPES_FROM_ORDER';
export const SCOPES_INITIALIZE_SCOPES = '@@SCOPES/INITIALIZE_SCOPES';
